module.exports = __webpack_public_path__ + "static/img/file-green.a9fc915a.svg";